import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login/Login.vue"),
    },
    {
      path: "/",
      component: () => import("./components/layout/TheContainer.vue"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home/Home.vue"),
        },
        /// Cadastros
        {
          path: "/cadastros/api-gateway",
          name: "api-gateway",
          component: () => import("./views/APIGateway/APIGateway.vue"),
        },
        {
          path: "/cadastros/colaboradores",
          name: "colaboradores",
          component: () => import("./views/Colaboradores/Colaboradores.vue"),
        },
        {
          path: "/cadastros/contratos-e-licencas",
          name: "contratos-e-licencas",
          component: () =>
            import("./views/ContratosLicencas/ContratosLicencas.vue"),
        },
        {
          path: "/cadastros/clientes",
          name: "clientes",
          component: () => import("./views/Clientes/Clientes.vue"),
        },
        {
            path: "/cadastros/como-conheceu",
            name: "como-conheceu",
            component: () => import("./views/Clientes/ComoConheceu.vue"),
        },
        {
          path: "/cadastros/conta-corrente",
          name: "conta-corrente",
          component: () => import("./views/ContaCorrente/ContaCorrente.vue"),
        },
        {
          path: "/cadastros/comissao",
          name: "comissao",
          component: () => import("./views/Comissao/Comissao.vue"),
        },
        {
          path: "/cadastros/grupos-grade",
          name: "grupos-grade",
          component: () => import("./views/GruposGrade/GruposGrade.vue"),
        },
        {
          path: "/cadastros/tintometrico",
          name: "tintometrico",
          component: () => import("./views/Tintometrico/Tintometrico.vue"),
        },
        {
          path: "/expediente/expediente",
          name: "expediente",
          component: () => import("./views/Expediente/Expediente.vue"),
        },
        {
          path: "/cadastros/faq",
          name: "faq",
          component: () => import("./views/Faq/Faq.vue"),
        },
        {
          path: "/cadastros/produtos",
          name: "produtos",
          component: () => import("./views/Produtos/Produtos.vue"),
        },
        {
          path: "/cadastros/precificacao-cliente-final",
          name: "precificacao-cliente-final",
          component: () =>
            import(
              "./views/PrecificacaoClienteFinal/PrecificacaoClienteFinal.vue"
            ),
        },
        {
          path: "/cadastros/sac",
          name: "sac",
          component: () => import("./views/Sac/Sac.vue"),
        },
        {
          path: "/cadastros/setores",
          name: "setores",
          component: () => import("./views/Setores/Setores.vue"),
        },
        {
          path: "/cadastros/agendas",
          name: "agendas",
          component: () => import("./views/Agendas/Agendas.vue"),
        },
        {
          path: "/cadastros/modulos",
          name: "modulos",
          component: () => import("./views/Modulos/Modulos.vue"),
        },
        {
          path: "/cadastros/perfis",
          name: "perfis",
          component: () => import("./views/Perfis/Perfis.vue"),
        },
        // Rota para testar componentes
        {
          path: "/cadastros/tag-filtro",
          name: "tag-filtro",
          component: () => import("./views/TagFiltro/TagFiltro.vue"),
        },
        {
          path: "/cadastros/restricoes-venda",
          name: "restricoes-venda",
          component: () => import("./views/RestricaoVenda/RestricaoVenda.vue"),
        },
        {
          path: "/cadastros/preco-negociado-motivo",
          name: "preco-negociado-motivo",
          component: () => import("./views/PrecoNegociadoMotivo/PrecoNegociadoMotivo.vue"),
        },
        {
          path: "/cadastros/concorrentes",
          name: "concorrentes",
          component: () => import("./views/Concorrente/Concorrente.vue"),
        },
        {
          path: "/cadastros/tipo-contato",
          name: "tipo-contato",
          component: () => import("./views/TipoContato/TipoContato.vue"),
        },

        /// Campanhas
        {
          path: "/campanhas/campanhas",
          redirect: "/campanhas/comerciais",
        },
        {
          path: "/campanhas/comerciais",
          name: "campanhas-comerciais-lista",
          component: () =>
            import(
              "./views/Campanhas/components/CampanhasComerciais/pages/CampanhaListagem.vue"
            ),
        },
        {
          path: "/campanhas/metas",
          name: "campanhas-metas",
          component: () => import("./views/Campanhas/components/ObjetivosOperadores/ObjetivosOperadores.vue"),
        },
        {
          path: "/campanhas/cupons",
          name: "cupons",
          component: () => import("./views/Cupons/Cupons.vue"),
          // props: { videos: ["sjyzxc830cw"] }
        },
        {
          path: "/campanhas/descontos",
          name: "descontos",
          component: () => import("./views/Descontos/Descontos.vue"),
        },
        {
          path: "/campanhas/precos-promocionais",
          name: "promocoes",
          component: () =>
            import("./views/PrecosPromocionais/PrecosPromocionais.vue"),
        },

        /// Marketing
        {
          path: "/marketing/banners",
          name: "banners",
          component: () => import("./views/Banners/Banners.vue"),
        },
        {
          path: "/marketing/vitrines",
          name: "vitrines",
          component: () => import("./views/Vitrines/Vitrines.vue"),
        },
        {
          path: "/marketing/links-integrados",
          name: "links-integrados",
          component: () => import("./views/LinkIntegracao/LinkIntegracao.vue"),
        },
        {
          path: "/marketing/galerias-imagens",
          name: "galerias-imagens",
          component: () => import("./views/Galeria/Galeria.vue"),
        },
        {
          path: "/marketing/catalogos",
          name: "catalogos",
          component: () => import("./views/Catalogos/Catalogos.vue"),
        },
        {
          path: "/marketing/canais-atendimento",
          name: "canais-atendimento",
          component: () =>
            import("./views/CanaisAtendimento/CanaisAtendimento.vue"),
        },
        {
          path: "/marketing/paginas",
          name: "paginas",
          component: () => import("./views/Paginas/Paginas.vue"),
        },
        {
          path: "/marketing/paginas/criar",
          name: "pagina-criar",
          component: () => import("./views/Paginas/PaginaForm.vue"),
        },
        {
          path: "/marketing/paginas/:id/editar",
          name: "pagina-editar",
          component: () => import("./views/Paginas/PaginaForm.vue"),
        },
        {
          path: "/marketing/postagens",
          name: "postagens",
          component: () => import("./views/Postagens/Postagens.vue"),
        },
        {
          path: "/marketing/postagens/criar",
          name: "postagem-criar",
          component: () => import("./views/Postagens/PostagemForm.vue"),
        },
        {
          path: "/marketing/postagens/:id/editar",
          name: "postagem-editar",
          component: () => import("./views/Postagens/PostagemForm.vue"),
        },
        {
          path: "/marketing/pagina-termos",
          name: "pagina-termos",
          component: () => import("./views/TermosLgpd/TermosLgpd.vue"),
        },
        {
          path: "/marketing/trabalhe-conosco",
          name: "trabalhe-conosco",
          component: () =>
            import("./views/TrabalheConosco/TrabalheConosco.vue"),
        },
        {
          path: "/marketing/links",
          name: "links",
          component: () => import("./views/Links/Links.vue"),
        },
        {
          path: "/marketing/conteudos-visuais",
          name: "conteudos-visuais",
          component: () => import("./views/ConteudosVisuais/ConteudosVisuais.vue"),
        },
        {
          path: "/marketing/logos",
          name: "logos",
          component: () => import("./views/Logos/Logos.vue"),
        },
        {
          path: "/marketing/secoes-rodape",
          name: "secoes-rodape",
          component: () => import("./views/SecoesRodape/SecoesRodape.vue"),
        },
        {
          path: "/marketing/departamentos",
          name: "departamentos",
          component: () => import("./views/Departamentos/Departamentos.vue"),
        },
        {
          path: "/marketing/marcas",
          name: "marcas",
          component: () => import("./views/Marcas/Marcas.vue"),
        },
        {
          path: "/cadastros/filiais",
          name: "filiais",
          component: () => import("./views/Filiais/Filiais.vue"),
        },
        {
          path: "/marketing/sociais",
          name: "sociais",
          component: () => import("./views/Sociais/Sociais.vue"),
        },
        {
          path: "/marketing/mershandising",
          name: "mershandising",
          component: () => import("./views/Mershandising/Mershandising.vue"),
        },
        {
          path: "/marketing/formularios",
          name: "formularios",
          component: () => import("./views/Formularios/Formularios.vue"),
          props: {
            filtroTipo: ["ACESSO_DADOS_PESSOAIS", "INCIDENTE_DADOS_PESSOAIS"],
          },
        },
        {
          path: "/marketing/formularios-pesquisa",
          name: "formularios-pesquisa",
          component: () => import("./views/FormularioPesquisa/Formularios.vue"),
          props: { filtroTipo: ["ORCAMENTO"] },
        },

        /// Regra de negócio
        {
          path: "/regra-negocio/regra",
          name: "regras-negocio",
          component: () => import("./views/RegraNegocio/RegraNegocio"),
        },
        {
          path: "/regra-negocio/sinaleira-lucratividade",
          name: "sinaleira-lucratividade",
          component: () => import("./views/SinaleiraLucratividade/SinaleiraLucratividade.vue"),
        },

        /// Entrega
        {
          path: "/entrega/condicao-entrega",
          name: "condicao-entrega",
          component: () => import("./views/Entrega/Entrega/CondicaoEntrega"),
        },
        {
          path: "/entrega/transporte",
          name: "transporte",
          component: () => import("./views/Entrega/Transporte/Transporte"),
        },

        /// Pagamento
        {
          path: "/pagamento/pagamento",
          name: "pagamento",
          component: () => import("./views/Pagamento/Pagamento.vue"),
        },
        {
          path: "/pagamento/condicao-pagamento",
          name: "condicao-pagamento",
          component: () =>
            import("./views/CondicaoPagamento/CondicaoPagamento.vue"),
        },

        /// Notificações
        {
          path: "/notificacoes/notificacoes",
          name: "notificacoes",
          component: () => import("./views/Notificacoes/Notificacoes.vue"),
        },

        /// Pedidos
        {
          path: "/pedidos/pedidos-pendentes-integracao",
          name: "pedidos-pendentes-integracao",
          component: () =>
            import(
              "./views/PedidoPendenteIntegracao/PedidoPendenteIntegracao.vue"
            ),
        },
        {
          path: "/pedidos/orcamentos-e-pedidos",
          name: "orcamentos-e-pedidos",
          component: () =>
            import(
              "./views/Pedidos/OrcamentosPedidos/ListaOrcamentosPedidos.vue"
            ),
        },
        {
          path: "/pedidos/pedidos-timeline",
          name: "pedidos-timeline",
          component: () => import("./views/Pedidos/Timeline/Timeline.vue"),
        },
        {
          path: "/pedidos/sugestoes-compra",
          name: "sugestoes-compra",
          component: () =>
            import("./views/SugestoesCompra/SugestoesCompra.vue"),
        },
        {
          path: "/pedidos/pedido-prioridade",
          name: "pedido-prioridade",
          component: () =>
            import("./views/PedidoPrioridade/PedidoPrioridade.vue"),
        },

        /// Configurações
        {
          path: "/configuracoes/configuracoes",
          name: "configuracoes",
          component: () => import("./views/Configuracoes/Configuracoes.vue"),
        },
        {
          path: "/configuracoes/dashboards",
          name: "dashboardas",
          component: () => import("./views/Dashboards/Dashboards.vue"),
        },
        {
          path: "/configuracoes/relatorios",
          name: "relatorios",
          component: () => import("./views/Relatorios/Relatorios.vue"),
        },
        {
          path: "/configuracoes/funis-acompanhamento",
          name: "funis-acompanhamento",
          component: () =>
            import("./views/FunilAcompanhamento/FunilAcompanhamento.vue"),
        },
        {
          path: "/configuracoes/views-templates",
          name: "views-templates",
          component: () => import("./views/ViewsTemplates/ViewsTemplates.vue"),
        },
        {
          path: "/configuracoes/templates-ia",
          name: "templates-ia",
          component: () => import("./views/TemplatesIA/TemplatesIA.vue"),
        },
        {
          path: "/configuracoes/configuracao-ia",
          name: "configuracao-ia",
          component: () =>
            import("./views/ConfiguracaoIA/ConfiguracaoIA.vue"),
        },
        {
          path: "/configuracoes/campos-integracao",
          name: "campos-integracao",
          component: () =>
            import("./views/CamposIntegracao/CamposIntegracao.vue"),
        },
        {
          path: "/configuracoes/campos-adicionais",
          name: "campos-adicionais",
          component: () =>
            import("./views/CamposAdicionais/CamposAdicionais.vue"),
        },
        {
          path: "/configuracoes/sql-erp-integracao",
          name: "sql-erp-integracao",
          component: () =>
            import("./views/SqlErpIntegracao/SqlErpIntegracao.vue"),
        },
        {
          path: "/configuracoes/parametros",
          name: "parametros",
          component: () => import("./views/Parametros/Parametros.vue"),
        },
        {
          path: "/configuracoes/cargas",
          name: "cargas",
          component: () => import("./views/CargaDados/CargaDados.vue"),
        },
        {
          path: "/configuracoes/logs",
          name: "logs",
          component: () => import("./views/Logs/Logs.vue"),
        },
        {
          path: "/configuracoes/webhooks",
          name: "webhooks",
          component: () => import("./views/Webhooks/Webhooks.vue"),
        },
        {
          path: "/configuracoes/formulas-calculo",
          name: "formulas-calculo",
          component: () => import("./views/FormulasCalculo/FormulasCalculo.vue"),
        },
        {
          path: "/configuracoes/formulas-calculo/:acao",
          name: "formula-calculo-editor",
          component: () => import("./views/FormulasCalculo/FormulaEditor.vue"),
        },

        // Rota para testar componentes
        {
          path: "/test-component",
          name: "test",
          component: () => import("./views/Test/TestComponent.vue"),
        },
      ],
    },
  ],
});
